import { RocketOutlined } from '@ant-design/icons'
import { Divider, Spin } from 'antd'
import cls from 'classnames'
import React from 'react'
import { useTranslation } from 'react-i18next'

import { useGetFeaturedGroupsQuery } from '@/generated/graphql'
import { DiscoverGroupCard } from '@/modules/group/group-card/group-card.component'

import s from '../../discover/all-groups/all-groups.module.less'

interface FeaturedGroupProps {
  categoryId: number | null
}

export const FeaturedGroup: React.FC<FeaturedGroupProps> = ({ categoryId }) => {
  const fetchCount = categoryId ? 4 : 8
  const { t } = useTranslation()

  const { data, loading } = useGetFeaturedGroupsQuery({
    fetchPolicy: 'cache-and-network',
    nextFetchPolicy: 'cache-first',
    notifyOnNetworkStatusChange: true,
    variables: {
      categoryId,
      count: fetchCount,
      withPosts: true,
      withFollowers: true,
    },
  })

  const groups = (data ? data.recommend.featuredGroups : []).slice().reverse()

  const loadingComponent = loading && (
    <div style={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
      <Spin delay={300} size='large' />
    </div>
  )

  return (
    <>
      {groups.length > 0 && (
        <div className={cls(s.container, s.featuredGroup)}>
          <div className={s.featuredTitle}>
            <RocketOutlined />
            {t('groups.featuredGroups')}
          </div>
          <div className={s.featuredGroupList}>
            {groups.map((g) => (
              <DiscoverGroupCard key={g.groupId} group={g} />
            ))}
          </div>
          {loadingComponent}
          <Divider className={s.divider} />
        </div>
      )}
    </>
  )
}
